import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function CircleInfo({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20 10C20 4.47686 15.5231 0 10 0C4.47686 0 0 4.47686 0 10C0 11.6982 0.424551 13.3374 1.2224 14.7951C1.83556 15.9145 2.65887 16.908 3.64474 17.7216C5.42283 19.1855 7.64993 20 10 20C15.5231 20 20 15.5231 20 10ZM1 10C1 5.02914 5.02914 1 10 1C14.9709 1 19 5.02914 19 10C19 14.9709 14.9709 19 10 19C7.88406 19 5.88107 18.2675 4.2808 16.95C3.39304 16.2173 2.65145 15.3224 2.09952 14.3148C1.38183 13.0035 1 11.5293 1 10ZM9.5 8.47413V14.5259C9.5 14.7877 9.72386 15 10 15C10.2761 15 10.5 14.7877 10.5 14.5259V8.47413C10.5 8.21227 10.2761 8 10 8C9.72386 8 9.5 8.21227 9.5 8.47413ZM10 5.2207C10.367 5.2207 10.665 5.5187 10.665 5.8857C10.665 6.2527 10.367 6.5507 10 6.5507C9.633 6.5507 9.335 6.2527 9.335 5.8857C9.335 5.5187 9.633 5.2207 10 5.2207Z'
        />
      </g>
    </svg>
  );
}
